import React from "react";
import PageLayout from "./PageLayout";
import Hero from "../sections/Hero";
import Pillar from "../sections/Pillar";
import Courses from "../sections/Courses";
import SummerProgram from "../sections/SummerProgram";
import Teachers from "../sections/Teachers";
import Gallery from "../sections/Gallery";
import ParentReviews from "../sections/ParentReviews";
import Contact from "../sections/Contact";

export default function Home() {
    return (
        <PageLayout testId="home-page">
            <Hero />
            <Pillar />
            <Courses />
            <SummerProgram />
            <Teachers />
            <Gallery />
            <ParentReviews />
            <Contact />
        </PageLayout>
    );
}
